import React from 'react'
import { Link } from 'gatsby'
import { css } from '@emotion/react'
import NavFacets from './nav-facets'
import { Index, useStats } from 'react-instantsearch'
import useGetAllBuilderTheWave from '../hooks/useGetAllBuilderTheWave'
import ArticleCard from './article-card'

const linkStyle = theme => css({
    fontFamily: theme.fonts.secondary,
    fontWeight: 700,
    textTransform: 'capitalize',
})

const dividerStyle = theme => css({ 
    marginTop: 24,
    paddingTop: 24, 
    borderTop: `1px solid ${theme.colors.mutedDark}`,
})

const articleListStyle = {
    maxWidth: '100%',
    marginTop: 20,
    display: 'grid',
    gap: 20,
    gridTemplateColumns: 'repeat(4, 1fr)',
}

export const Links = (props) => {
    const { nbHits } = useStats()
    return(
        <>
            <Link to='/the-wave' css={linkStyle} {...props}>
                View all articles ({nbHits})
            </Link>
        </>
    )
}

export default function NavTheWave() {
    const articles = useGetAllBuilderTheWave()
        .filter(({ data }) => data.featured)

    return <Index indexName='builder-moog-the-wave'>
        <div css={{ marginBottom: 24, }}><Links /></div>
        <NavFacets rootPath='The Wave' />
        <h4 css={[dividerStyle, { marginBottom: 20 }]}>Featured Articles</h4> 
        <div css={articleListStyle}>
            {articles.map((article, i) => <ArticleCard key={`${article.objectID}-${i}`} article={article} />)}
        </div>
    </Index>
}
